import React from "react";
import Typography from "@mui/material/Typography";
import { formatEmpty, formatWeight } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function WeightCell(cell) {
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          color: active ? "white_opacity.100" : "black_solid.80",
        }}
      >
        {formatEmpty(formatWeight(cell.value))}
      </Typography>
    </span>
  );
}
